import { ArrowRight } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import ButtonLink from '../ButtonLink';
import css from './JumperButtons.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JumperButtons = function JumperButtons(_ref) {
  var buttons = _ref.buttons,
      ctaDest = _ref.ctaDest,
      ctaTitle = _ref.ctaTitle,
      currentIndex = _ref.currentIndex,
      _onClick = _ref.onClick,
      title = _ref.title;
  var showCTA = ctaDest !== '' && ctaTitle !== '';
  var wrapEl = useRef(null);
  var firstChildEl = useRef(null);
  useEffect(function () {
    var _wrapEl$current;

    var left = firstChildEl.current.offsetWidth * currentIndex;

    if (wrapEl.current.scrollLeft === left) {
      return;
    }

    if ((_wrapEl$current = wrapEl.current) !== null && _wrapEl$current !== void 0 && _wrapEl$current.scrollTo) wrapEl.current.scrollTo({
      left: left,
      behavior: 'smooth'
    });
  }, [currentIndex]);
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    id: "jump-nav",
    children: [title && /*#__PURE__*/_jsx("div", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: css.buttons,
      ref: wrapEl,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.wrap,
        children: buttons.map(function (_ref2, idx) {
          var buttonTitle = _ref2.title,
              slug = _ref2.slug;
          return /*#__PURE__*/_jsx("div", {
            className: css.button,
            ref: idx === 0 ? firstChildEl : null,
            children: /*#__PURE__*/_jsx(ButtonLink, {
              "aria-label": "Anchor further down the page to ".concat(buttonTitle, " section"),
              href: "#".concat(slug),
              onClick: function onClick() {
                return _onClick(idx);
              },
              full: true,
              gray: idx !== currentIndex,
              children: buttonTitle
            })
          }, slug);
        })
      }), showCTA && /*#__PURE__*/_jsxs("a", {
        href: ctaDest,
        className: css.cta,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.title,
          children: ctaTitle
        }), /*#__PURE__*/_jsx(ArrowRight, {})]
      })]
    })]
  });
};

JumperButtons.displayName = 'JumperButtons';
JumperButtons.defaultProps = {
  ctaDest: '',
  ctaTitle: '',
  title: false
};
JumperButtons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape).isRequired,
  ctaDest: PropTypes.string,
  ctaTitle: PropTypes.string,
  currentIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default JumperButtons;